import {
  HOMEPAGE_SECTION_IDS,
  type HomepageSectionOrderItem,
  type HomepageSectionId,
} from "lib/types/homepage";

export const DEFAULT_HOMEPAGE_SECTIONS_ORDER = [...HOMEPAGE_SECTION_IDS];

const HOMEPAGE_SECTION_IDS_SET = new Set<string>(HOMEPAGE_SECTION_IDS);

export const isHomepageSectionId = (
  value: string
): value is HomepageSectionId => HOMEPAGE_SECTION_IDS_SET.has(value);

export const normalizeHomepageSectionsOrder = (
  sectionsOrder?:
    | HomepageSectionOrderItem[]
    | HomepageSectionId[]
    | string[]
    | null
): HomepageSectionId[] => {
  if (!sectionsOrder || sectionsOrder.length === 0) {
    return DEFAULT_HOMEPAGE_SECTIONS_ORDER;
  }

  const uniqueSections = new Set<HomepageSectionId>();

  sectionsOrder.forEach((sectionValue) => {
    const sectionId =
      typeof sectionValue === "string" ? sectionValue : sectionValue?.text;

    if (isHomepageSectionId(sectionId)) {
      uniqueSections.add(sectionId);
    }
  });

  const normalizedSections = Array.from(uniqueSections);

  DEFAULT_HOMEPAGE_SECTIONS_ORDER.forEach((sectionId) => {
    if (!uniqueSections.has(sectionId)) {
      normalizedSections.push(sectionId);
    }
  });

  return normalizedSections;
};
